"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeader = void 0;
var table_header_component_1 = require("./table-header.component");
Object.defineProperty(exports, "TableHeader", { enumerable: true, get: function () { return table_header_component_1.TableHeader; } });
